var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Picture',{attrs:{"images":_vm.info.images,"name":_vm.info.name + ' members photo'}}),_c('h5',{staticClass:"information"},[_vm._v("Popularity: "+_vm._s(_vm.info.popularity))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }